import React, { useState } from 'react';
import CommunicativeSituationsExercise from './CommunicativeSituationsExercise';
import './CommunicativeSituationsExerciseBoard.css';

const COMMUNICATIVE_SITUATIONS_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)', marginRight: 20, flexShrink: 0
  }}>
    <svg viewBox="0 0 48 48" width="28" height="28" fill="white" xmlns="http://www.w3.org/2000/svg">
      <g id="Chat">
        <path d="m45 1h-28a2 2 0 0 0 -2 2v20a2 2 0 0 0 2 2h18s0 0 8 4v-4h2a2 2 0 0 0 2-2v-20a2 2 0 0 0 -2-2zm-23 14a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm9 0a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm9 0a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"/>
        <path d="m13 23v-4h-10a2 2 0 0 0 -2 2v20a2 2 0 0 0 2 2h2v4c8.08-4 7.85-4 8-4h18.05a2 2 0 0 0 2-2v-14h-16.05a4 4 0 0 1 -4-4zm-5 10a2 2 0 1 1 2-2 2 2 0 0 1 -2 2zm18-4a2 2 0 1 1 -2 2 2 2 0 0 1 2-2zm-7 2a2 2 0 1 1 -2-2 2 2 0 0 1 2 2z"/>
      </g>
    </svg>
  </span>
);

const CommunicativeSituationsExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { situations, title, level, topic, vocab } = exerciseData;

  if (!situations || !Array.isArray(situations)) {
    return (
      <div className="communicative-situations-board-error">
        <p>Error: Invalid Communicative Situations exercise data</p>
      </div>
    );
  }

  const handleExpand = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(true);
    if (onSelect) onSelect();
    if (onExpand) onExpand();
  };

  const handleClose = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(false);
    if (onClose) onClose();
  };

  return (
    <div className="communicative-situations-exercise-board">
      {!isExpanded ? (
        <div
          className={`communicative-situations-preview unified-exercise-preview cs-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={handleExpand}
        >
          {COMMUNICATIVE_SITUATIONS_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Communicative Situations Exercise'}</div>
            <div className="unified-preview-meta">
              {situations.length} situations · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="communicative-situations-expanded">
          <CommunicativeSituationsExercise
            situations={situations}
            title={title}
            level={level}
            topic={topic}
            vocab={vocab}
            onClose={handleClose}
            updateAttributes={onUpdate}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default CommunicativeSituationsExerciseBoard;
